import { ModelsFilter } from '@spo/logic';
import { apiModels } from '@spo/services/api';
import { useQuery } from '@tanstack/react-query';

export const useModels = (ids: ModelsFilter, offerDate: string | undefined) => {
  const { smIds, modelIds } = ids;
  return useQuery({
    queryKey: ['useModels', ids],
    queryFn: () => {
      if (offerDate && offerDate.length > 0)
        return apiModels.getModels({
          smIds,
          modelIds,
          offerDate,
        });
    },
    enabled: (smIds.length > 0 || modelIds.length > 0) && !!offerDate,
    select: (data) => data && data.sort((a, b) => Number(b.id) - Number(a.id)),
  });
};
